import type { Control } from "react-hook-form";
import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { BuildingFormFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingFormFields";
import { getBuildingDescriptionLabel } from "web_myplann/Portfolio/Forms/BuildingShared/buildingDescriptionLabel";
import type {
	CottageFormInput,
	CottageFormOutput,
} from "web_myplann/Portfolio/Forms/CottageForm/cottageFormSchema";

type CottageFormFieldsProps = {
	control: Control<CottageFormInput, unknown, CottageFormOutput>;
};

export const CottageFormFields = ({ control }: CottageFormFieldsProps) => {
	const { t } = useResource();

	return (
		<BuildingFormFields
			control={control}
			descriptionLabel={getBuildingDescriptionLabel(
				t,
				ClientPropertyTypeEnum.Cottage,
			)}
		/>
	);
};
